import { KbvPluginService } from "@/services/kbvPluginService";
import { useEffect, useState, useCallback } from "react";

const EMPTY_LEAGUES = [];

function normalizeLeague(league) {
  if (!league) return null;
  const id = String(league.id ?? league.name ?? "");
  return {
    id,
    name: league.name ?? league.nameVN ?? "",
    nameVN: league.nameVN ?? league.name ?? "",
    logo: league.logo ?? null,
    slug: league.slug ?? null,
  };
}

export function toList(response) {
  const list = response?.data?.data ?? response?.data;
  return Array.isArray(list) ? list : [];
}

export async function searchLeaguesByKeyword(searchKeyword) {
  if (!searchKeyword || typeof searchKeyword !== "string") {
    return EMPTY_LEAGUES;
  }
  const trimmed = searchKeyword.trim();
  if (!trimmed) return EMPTY_LEAGUES;

  try {
    const params = {
      search: trimmed,
      fields: "id,name,country,countryId,logo,countryLogo,slug",
      include: "",
      sort: "",
      page: 1,
      limit: 100,
    };
    const response = await KbvPluginService.getLeagues(params);
    return response;
  } catch (error) {
    console.error("searchLeaguesByKeyword error:", error);
    return EMPTY_LEAGUES;
  }
}

export async function fetchHotLeagues() {
  try {
    const response = await KbvPluginService.getHotLeagues({
      page: 1,
      limit: 10,
      fields: "id,name,logo,slug,nameVN",
    });
    return response
  } catch (error) {
    console.error("fetchHotLeagues error:", error);
    return EMPTY_LEAGUES;
  }
}


export function useRemoteLeagueSearch({ enabled, keyword }) {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const clear = useCallback(() => {
    setResults([]);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!enabled || !keyword) return;
    let cancelled = false;
    setIsLoading(true);
    (async () => {
      try {
        const leagues = await searchLeaguesByKeyword(keyword);
        if (!cancelled) setResults(leagues);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, keyword]);

  const active = enabled && keyword;
  return {
    results: active ? results : [],
    isLoading: active ? isLoading : false,
    clear,
  };
}
